import {
    Component,
    ElementRef,
    Inject,
    LOCALE_ID,
    OnDestroy,
    OnInit, Renderer2,
    ViewChild
} from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {Globals} from '@app/services/globals.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {formatDate} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {History} from '@app/interfaces/history';
import {Subscription} from 'rxjs';
import {MyWebDeskService} from "@components/my-web-desk/my-web-desk.service";
import {document} from "ngx-bootstrap/utils";
import {HelperService} from "@app/services/helper/helper.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {OdmoriService} from '@app/components/odmori/odmori.service';


export interface Track {
    title: string;
    id: string;
    tasks: any[];
    button: boolean
}

export interface Task {
    id: string;
    title: string;
    description: string;
    borderColor: string;
    titleIcon: string;
    project: string;
    subtask: any;
}

export interface Filters {
    title: '';
    projects: any[];
    deadline: any[];
    taskType: any[];

}

@Component({
    selector: 'app-content-kanban',
    templateUrl: './content-kanban.component.html',
    styleUrls: ['./content-kanban.component.css'],
    providers: [Globals] // this depends on situation, see below
})
export class ContentKanbanComponent implements OnInit, OnDestroy {
    status = 'inprogress';

    data;
    allTasks;
    filteredTasks = [];
    firstArray = [];
    user: any[];
    allToDo = [];
    allInProgress = [];
    allDone = [];

    buttonDisabled = false;
    loader = false;
    kanbanTable = true;
    kanbanList = false;


    filters: Filters = {
        title: '', projects: [], taskType: [{
            name: 'Sastanak',
            value: 'meeting',
            checked: true

        },
            {
                name: 'Zadatak',
                value: 'task',
                checked: true

            }], deadline: []
    };
    listButtons = {todo: true, inprogress: true, ddone: true};
    public tracks: Track[] = [
        {
            title: 'Novi',
            id: 'todo',
            tasks: [],
            button: this.listButtons.todo

        },
        {
            title: 'U radu',
            id: 'inprogress',
            tasks: [],
            button: this.listButtons.inprogress
        },
        {
            title: 'Završeni',
            id: 'ddone',
            tasks: [],
            button: this.listButtons.ddone
        }
    ];


    @ViewChild('tasksList') input: ElementRef;

    private subscriptions: Subscription;
    private filterSubscription: Subscription;
    private kanbanPreviewSubscription: Subscription;


    constructor(public taskService: TaskService,
                public proventumApiService: ProventumApiService,
                public globals: Globals,
                public constants: ConstantsService,
                @Inject(LOCALE_ID) private locale: string,
                private toastr: ToastrService,
                private myWebDeskSrv: MyWebDeskService,
                private renderer: Renderer2,
                private helperSrv: HelperService,
                private odmoriService: OdmoriService) {
        this.subscriptions = this.taskService.taskCreated.subscribe(async (result) => {
            if (result === 'task' || result == 'meeting') {
                const response = await this.ngOnInit();
            }
        });
        this.filterSubscription = this.myWebDeskSrv.kanbanFilters.subscribe(data => {
            if (Object.values(data).length > 0) {
                this.filterTasks(data.data);
            }
        });

        this.kanbanPreviewSubscription = this.myWebDeskSrv.kanbanPreview.subscribe(result => {
            if (result == 'table') {
                this.kanbanTable = true;
                this.kanbanList = !this.kanbanTable;
            } else {
                this.kanbanList = true;
                this.kanbanTable = !this.kanbanList;
            }
            localStorage.setItem('kanbanPreview', result);
        });
        let kanbanPreviewType = localStorage.getItem('kanbanPreview');
        if (kanbanPreviewType == 'undefined' || kanbanPreviewType == 'null') {
            localStorage.setItem('kanbanPreview', 'table');
        }
    }

    async ngOnInit() {

        try {
            let kanbanPreviewType = localStorage.getItem('kanbanPreview');
            if (kanbanPreviewType !== 'undefined' && kanbanPreviewType != 'null') {
                this.kanbanTable = kanbanPreviewType === 'table' ? true : false;
                this.kanbanList = !this.kanbanTable;
            }
            this.listButtons = this.myWebDeskSrv.getKanbanListState();

            const getTasksFunction = await this.getTasks();

            const rearrangeTasksInTracks = await this.arrangeTasksInTracks();

            const filterTasksHandler = await this.filterTasks(this.filters);

            const checkUnfinishedTasksInPeriod = this.checkUnfinishedTasksInPeriod();

            this.loader = true;
        } catch (e) {

        }

    }


    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
    }


    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.filterSubscription.unsubscribe();
    }

    get trackIds(): string[] {
        return this.tracks.map(track => track.id);
    }


    async filterTasks(data) {
        this.filters = data;
        this.tracks[0]['tasks'] = this.allToDo;
        this.tracks[1]['tasks'] = this.allInProgress;
        this.tracks[2]['tasks'] = this.allDone;
        if (data.projects.length > 0) {
            const filter1 = await this.filterProjects(data.projects);
        }

        if (data.deadline.length > 0) {
            const filter2 = await this.filterDeadline(data.deadline);
        }
        if (data.taskType.length < 2) {
            const filter3 = await this.filterTypes(data.taskType);
        }


        if (data.title !== '') {
            this.tracks[0]['tasks'] = this.tracks[0]['tasks'].filter(x => x.title.toLowerCase().includes(data.title.toLowerCase()));
            this.tracks[1]['tasks'] = this.tracks[1]['tasks'].filter(x => x.title.toLowerCase().includes(data.title.toLowerCase()));
            this.tracks[2]['tasks'] = this.tracks[2]['tasks'].filter(x => x.title.toLowerCase().includes(data.title.toLowerCase()));
        }
    }

    filterProjects(data) {
        this.tracks[0]['tasks'] = new Array(0);
        this.tracks[1]['tasks'] = new Array(0);
        this.tracks[2]['tasks'] = new Array(0);
        data.forEach((item) => {

            let todo: any[] = this.allToDo.filter(x => x.project_id === item._id);
            let progress: any[] = this.allInProgress.filter(x => x.project_id === item._id);
            let ddone: any[] = this.allDone.filter(x => x.project_id === item._id);

            this.tracks[0]['tasks'] = this.tracks[0]['tasks'].concat(todo);
            this.tracks[1]['tasks'] = this.tracks[1]['tasks'].concat(progress);
            this.tracks[2]['tasks'] = this.tracks[2]['tasks'].concat(ddone);
        });
    }

    filterTypes(data) {
        if (data.length === 1) {
            this.tracks[0]['tasks'] = this.tracks[0]['tasks'].filter(x => x.type === data[0].value);
            this.tracks[1]['tasks'] = this.tracks[1]['tasks'].filter(x => x.type === data[0].value);
            this.tracks[2]['tasks'] = this.tracks[2]['tasks'].filter(x => x.type === data[0].value);
        } else if (data.length === 0) {
            this.tracks[0]['tasks'] = new Array(0);
            this.tracks[1]['tasks'] = new Array(0);
            this.tracks[2]['tasks'] = new Array(0);
        }
    }

    filterDeadline(data) {
        const item = data[0].value;
        let startRange = new Date();
        startRange.setHours(0, 0);
        let endRange = new Date();
        endRange.setHours(23, 59, 59);
        switch (item) {
            case 'today':
                this.tracks[0]['tasks'] = this.tracks[0]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline > startRange && deadline < endRange);
                });
                this.tracks[1]['tasks'] = this.tracks[1]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline > startRange && deadline < endRange);
                });
                this.tracks[2]['tasks'] = this.tracks[2]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline > startRange && deadline < endRange);
                });
                break;

            case 'tomorrow':
                startRange.setDate(startRange.getDate() + 1);
                startRange.setHours(0, 0, 0);
                endRange.setDate(startRange.getDate());
                endRange.setHours(23, 59, 59);
                this.tracks[0]['tasks'] = this.tracks[0]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline > startRange && deadline < endRange);
                });
                this.tracks[1]['tasks'] = this.tracks[1]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline > startRange && deadline < endRange);
                });
                this.tracks[2]['tasks'] = this.tracks[2]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline > startRange && deadline < endRange);
                });
                break;


            case 'next_7_days':
                endRange.setDate(startRange.getDate() + 7);
                endRange.setHours(23, 59, 59);
                this.tracks[0]['tasks'] = this.tracks[0]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline < endRange);
                });
                this.tracks[1]['tasks'] = this.tracks[1]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline < endRange);
                });
                this.tracks[2]['tasks'] = this.tracks[2]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline <= endRange);
                });
                break;

            case 'next_30_days':
                endRange.setDate(startRange.getDate() + 30);
                endRange.setHours(23, 59, 59);
                this.tracks[0]['tasks'] = this.tracks[0]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline < endRange);
                });
                this.tracks[1]['tasks'] = this.tracks[1]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline < endRange);
                });
                this.tracks[2]['tasks'] = this.tracks[2]['tasks'].filter(x => {
                    const deadline = new Date(x.deadline);
                    return (deadline <= endRange);
                });
                break;


        }
    }

    async onTalkDrop(event: CdkDragDrop<Task[]>) {
        if (event.container.id === event.previousContainer.id) {
            this.toastr.info('Zadatak možete prebaciti samo u kolonu različitu od trenutne.')
            return;
        }
        const task = event.previousContainer.data[event.previousIndex];
        const task_id = event.previousContainer.data[event.previousIndex]['_id'];
        const new_status = event.container.id;
        this.status = new_status;

        let subtasks = [];


        subtasks = task['subtasks'];
        let checked = true;
        let check = new Promise(((resolve, reject) => {
            if (subtasks.length > 0 && new_status === 'ddone') {
                subtasks.forEach(item => {
                    if (item.status !== 'validated') {
                        this.toastr.info('Podzadaci nisu završeni.');
                        checked = false;

                    }
                });
            }
            resolve(checked);
        })).then(async () => {
            if (checked == true) {
                if (event.previousContainer === event.container) {
                    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
                } else {

                    task['track'] = new_status;
                    let items = {
                        _id: task['_id'],
                        sort: task['sort'],
                        project_id: task['project_id'],
                        identifier: task['identifier']

                    };
                    const fun = await this.changeStatusOfTask(items, new_status);
                    transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
                    if (task['play'] === true && new_status !== 'inprogress') {
                        let r = await this.taskActivity('stop', task);
                        this.taskService.statusInit.next(true);
                    }
                }
            } else {
                return;
            }

        });


        // In case the destination container is different from the previous container, we
        // need to transfer the given task to the target data array. This happens if
        // a task has been dropped on a different track.


    }

    onTrackDrop(event: CdkDragDrop<Track[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

    }

    changeStatusOfTask(task, status) {
        this.user = this.constants.userData;
        let message = 'Korisnik ' + this.user['first_name'] + ' ' + this.user['last_name'] + ' je promijenio status taska u "Otvoren".';
        if (status === 'inprogress') {
            message = 'Korisnik ' + this.user['first_name'] + ' ' + this.user['last_name'] + ' je promijenio status taska u "U radu".';
        } else if (status === 'ddone') {
            message = 'Korisnik ' + this.user['first_name'] + ' ' + this.user['last_name'] + ' je promijenio status taska u "Završeno."';
        }
        const data = {
            task: JSON.stringify(task),
            status: status,
        };
        this.taskService.changeStatusOfTask(data).subscribe(async (response) => {
            if (response.type == 'success') {

                if (status !== 'inprogress') {
                    this.taskService.statusInit.next(true);
                }
                const items: History = {
                    task_id: task._id,
                    user_id: parseInt(this.constants.creator_id, 10),
                    action: 'update',
                    type: 'status',
                    sort: task.sort,
                    message: message,
                    data: {type: status},
                    task_identifier: task.identifier
                };
                this.saveTaskChange(items);

            }
        }, error => {
            this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            return;
        });
    }


    async taskActivity(type, taskData) {
        let correct = true;
        this.buttonDisabled = true;
        let check = new Promise(((resolve, reject) => {
            if (type === 'play') {
                this.tracks[1]['tasks'].forEach(item => {
                        if (item['play'] === true) {
                            this.buttonDisabled = false;
                            correct = false;
                            return;
                        }
                    }
                );
            }
            resolve(correct);
        }));

        check.then(() => {
            if (correct) {
                const items = {
                    _id: taskData._id,
                    sort: taskData.sort,
                    identifier: taskData.identifier,
                    assigned: taskData.assigned,
                    project_id: taskData.project_id
                };
                let response = this.taskService.taskDuration(type, items).toPromise().then((data) => {
                    let id = taskData._id;
                    let key: number;
                    if (taskData.track === 'todo') {
                        key = 0;
                    } else if (taskData.track === 'inprogress') {
                        key = 1;
                    } else {
                        key = 2;
                    }
                    if (data.type === 'success') {
                        let item = this.tracks[key]['tasks'].find(x => x._id === id);
                        item['play'] = type === 'play';
                        this.buttonDisabled = false;
                        if (type === 'stop') {
                            this.taskService.statusInit.next(true);
                        }

                    }
                });
            } else {
                this.toastr.info('Već postoji pokrenut zadatak.');
            }
        });


    }

    show(item) {
        item.visibility = !item.visibility;
    }

    getTasks() {
        return new Promise((resolve, reject) => {
            try {
                let response = this.taskService.getAll().subscribe(async (data) => {
                    this.allTasks = data;
                    this.data = data;
                    this.allTasks.forEach(item => {
                        if (item.type === 'task') {
                            item.deadlineString = this.helperSrv.getDateAndMonthName(item.deadline);

                        } else if (item.type == 'meeting') {
                            item.meetingStart = this.helperSrv.getDateAndMonthName(item.meeting_time.start);
                        }
                    });
                    await this.filterTasks(this.filters);
                    resolve();
                });
            } catch (e) {
                reject(e);
            }
        });
    }

    arrangeTasksInTracks() {
        return new Promise((resolve, reject) => {

            try {
                let toDos = [];
                let proGresso = [];
                let completo = [];
                Object.keys(this.allTasks).forEach(key => {

                    var assignedArray = [];
                    var assignedIdis = this.allTasks[key]['assigned'];
                    Object.keys(assignedIdis).forEach(subkey => {
                        assignedArray.push(this.proventumApiService.getAssigned(assignedIdis[subkey]));
                    });
                    this.allTasks[key]['assigned'] = assignedArray;
                    this.allTasks[key]['visibility'] = false;

                    if (this.allTasks[key]['track'] === 'todo') {
                        toDos.push(this.allTasks[key]);

                        toDos.forEach(item => {
                            let subtasks = item.subtasks;
                            if (subtasks.length > 0) {
                                subtasks.forEach(val => {
                                    val['assignedUserData'] = [];
                                    val['assignedUserData'].push(this.proventumApiService.getAssigned(val['assigned'][0]));
                                });


                            }
                        });

                    } else if (this.allTasks[key]['track'] === 'inprogress') {
                        proGresso.push(this.allTasks[key]);
                        proGresso.forEach(item => {
                            let subtasks = item.subtasks;
                            if (subtasks.length > 0) {
                                subtasks.forEach(val => {
                                    val['assignedUserData'] = [];
                                    val['assignedUserData'].push(this.proventumApiService.getAssigned(val['assigned'][0]));
                                });


                            }
                        });
                    } else if (this.allTasks[key]['track'] === 'ddone') {
                        completo.push(this.allTasks[key]);
                        completo.forEach(item => {
                            let subtasks = item.subtasks;
                            if (subtasks.length > 0) {
                                subtasks.forEach(val => {
                                    val['assignedUserData'] = [];
                                    val['assignedUserData'].push(this.proventumApiService.getAssigned(val['assigned'][0]));
                                });


                            }
                        });
                    }
                });

                this.tracks[0]['tasks'] = toDos;
                this.tracks[1]['tasks'] = proGresso;
                this.tracks[2]['tasks'] = completo;

                this.allToDo = toDos;
                this.allInProgress = proGresso;
                this.allDone = completo;
                resolve();
            } catch (e) {
                reject(e);
            }

        });

    }

    openTasksSectionHandler(type) {
        this.myWebDeskSrv.setKanbanListState(this.listButtons);
        switch (type) {
            case 'todo':
                if (this.listButtons.todo) {
                    let element = document.getElementById('openTodos');
                    if (element != null) {
                        this.renderer.removeClass(element, 'rotate-span-up');
                        this.renderer.addClass(element, 'rotate-span-down');
                    }


                } else {
                    let element = document.getElementById('openTodos');
                    if (element != null) {
                        this.renderer.removeClass(element, 'rotate-span-down');
                        this.renderer.addClass(element, 'rotate-span-up');
                    }

                }

                break;

            case 'inprogress':
                if (this.listButtons.inprogress) {

                    let element = document.getElementById('openInProgress');
                    if (element != null) {
                        this.renderer.removeClass(element, 'rotate-span-up');
                        this.renderer.addClass(element, 'rotate-span-down');
                    }


                } else {
                    let element = document.getElementById('openInProgress');
                    if (element != null) {
                        this.renderer.removeClass(element, 'rotate-span-down');
                        this.renderer.addClass(element, 'rotate-span-up');
                    }


                }

                break;

            case 'ddone':
                if (this.listButtons.ddone) {
                    let element = document.getElementById('openDdone');
                    if (element != null) {
                        this.renderer.removeClass(element, 'rotate-span-up');
                        this.renderer.addClass(element, 'rotate-span-down');
                    }


                } else {
                    let element = document.getElementById('openDdone');
                    if (element != null) {
                        this.renderer.removeClass(element, 'rotate-span-down');
                        this.renderer.addClass(element, 'rotate-span-up');
                    }

                }
                break;
        }
    }

    saveTaskChange(data: History) {
        this.taskService.taskChange(data).subscribe((response: BackendResponse) => {
            if (response.type) {
                this.getTasks();
            } else {
                this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            }

        });
    }

    checkUnfinishedTasksInPeriod() {
        this.odmoriService.checkUnfinishedTasksInPeriod().subscribe(response => {
            if (response.type == 'success') {
                return;
            };

            this.toastr.error('Došlo je do greške. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

}

